import css from 'styled-jsx/css';

const styles = css.global`.clean-button {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
}
`;

export default styles;